import React from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'
import Home from './pages';
import ContactusPage from './pages/contactus';
import DisclaimerPage from './pages/disclaimer';
import PrivacyNoticePage from './pages/privacynotice';
import TermsofServicePage from './pages/termsofservice';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} exact />
        <Route path="aboutus" element={<Home />} exact />
        <Route path="/contactus" element={<ContactusPage />} exact />
        <Route path="/disclaimer" element={<DisclaimerPage />} exact />
        <Route path="/privacynotice" element={<PrivacyNoticePage />} exact />
        <Route path="/termsofservice" element={<TermsofServicePage />} exact />
      </Routes>
    </Router>
  );
}

export default App;
